(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sl-counter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sl-counter-value')) {
    customElements.define('sl-counter-value', class extends HTMLElement {
      connectedCallback() {
        this.numberEl = this.querySelector('[data-number]');
        if (!this.numberEl) return;
        this.target = parseInt(this.dataset.target, 10) || 0;
        this.duration = (parseFloat(this.dataset.duration) || 0) * 1000;
        this.separator = this.dataset.separator === 'none' ? '' : (this.dataset.separator || '');
        this.done = false;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || this.duration <= 0) {
          this.render(this.target);
          return;
        }

        this.render(0);
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.done) {
              this.done = true;
              this.animate();
              this.observer.disconnect();
            }
          });
        }, { threshold: 0.35 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      animate() {
        const start = performance.now();
        const tick = (now) => {
          const progress = Math.min((now - start) / this.duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.render(Math.round(this.target * eased));
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }

      render(value) {
        this.numberEl.textContent = this.format(value);
      }

      format(value) {
        if (!this.separator) return String(value);
        return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, this.separator);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
